import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { idbStorage } from './storage';

// Production uses custom domain; local dev uses .env.local override:
//   VITE_SUPABASE_URL=http://127.0.0.1:54321
//   VITE_SUPABASE_ANON_KEY=<local-anon-key>
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL?.includes('127.0.0.1')
  ? import.meta.env.VITE_SUPABASE_URL
  : "https://app.playsocrates.com";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBqa2lnZXBieWVrZXFxcmR4dW5qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3NzkyMjAsImV4cCI6MjA2ODM1NTIyMH0.-n4Jlxhn2UPlNKiU1ezH-rXWA-N3a5ppcZXBoVVBHhM";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: idbStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Log which environment we're connected to (dev only)
if (import.meta.env.DEV) {
  const isLocal = SUPABASE_URL.includes('127.0.0.1') || SUPABASE_URL.includes('localhost');
  console.log(`🔌 Supabase: ${isLocal ? 'LOCAL' : 'PRODUCTION'} (${SUPABASE_URL})`);
}
